import React, { useState, useEffect } from 'react';
import { Box, useMediaQuery } from '@material-ui/core';
import { useTranslate, useDataProvider, Title, usePermissions, Loading } from 'react-admin';
import { useAuthProvider } from 'ra-core';
import PageListLabel from '../page-list-label';
import RemoteTable from './RemoteTable';
import Snackbar from '../common/snackbar';
import { useLocation } from 'react-router';
import ConfirmDialog from '../CustomizedUIs/confirmDialog';

let timeoutDelete = null;
export const List = ({ }) => {
    const authProvider = useAuthProvider();
    const { permissions, loaded } = usePermissions();
    const [isPermission, setIsPermission] = useState(true);
    const translate = useTranslate();
    const dataProvider = useDataProvider();
    const [loading, setLoading] = useState(true);
    const location = useLocation();
    const isDesktop = useMediaQuery(theme => theme.breakpoints.up('md'));
    const [data, setData] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [search, setSearchText] = useState('');
    const [showSnackbarDelete, setShowSnackbarDelete] = useState(false);
    const [showSnackbar, setShowSnackbar] = useState(false)
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
    const [sort, setSort] = useState({
        field: 'name',
        order: 'ASC'
    })
    const [pagination, setPagination] = useState({
        page: 1,
        perPage: 10
    })

    const getList = () => {

        let filter = {}
        if (search.trim() && search.length > 0) {
            filter = {
                or: [
                    { name: { contains: search.trim() } },
                    { description: { contains: search.trim() } },
                ]
            };

        }
        dataProvider('GET_LIST', "remotes", {
            filter,
            pagination,
            sort,
        }).then(response => {
            if (response.success) {
                setData(response.data);
                setTotalCount(response.total);
            }
        }).catch(error => {
            // if (error.message === 'permissionIncorect') {
            //     setIsPermission(false)
            //     authProvider.resetFunctionAction()
            // }
        });
    }

    // const handleDelete = (item) => {
    //     setShowSnackbarDelete(true);
    //     const newList = data.filter(e => e.id !== item.id);
    //     setData(newList);

    //     timeoutDelete = setTimeout(() => {
    //         setShowSnackbarDelete(false);

    //         dataProvider('DELETE', 'remotes', {
    //             id: item.id
    //         }).then((data) => {
    //             getList();
    //         }).catch(error => {
    //             // TODO: Should show error message
    //             if (error.message === 'permissionIncorect') {
    //                 setIsPermission(false)
    //             }
    //         });
    //     }, 6000);
    // };
    const handleDelete = () => {
        var requests = []
        data.forEach(element => {
            element.checked && requests.push(
                dataProvider('DELETE', "remotes", {
                    id: element.id
                })
            )
        })
        if (requests.length > 0) {
            Promise.all(requests).then(() => {
                getList()
                setOpenConfirmDialog(false)
            }).catch(error => {
                setOpenConfirmDialog(false)
            });
        }
        else
            setOpenConfirmDialog(false)

    }

    const handleCheckMark = (event, index, checkAll) => {
        let temps = data.slice()
        if (!checkAll)
            temps[index].checked = event.target.checked
        else
            temps.map(item => {
                item.checked = event.target.checked
                return item
            })
        setData(temps)
    }

    const onClear = () => {
        let temps = data.slice()
        temps.map(item => {
            delete item.checked
            return item
        })
        setData(temps)
    }


    // const onGetListUser = (sortObj, paginationObj) => {

    //     pagination = paginationObj;
    //     sort = sortObj;
    //     getListUser();
    // }

    const undoDelete = () => {
        clearTimeout(timeoutDelete);
        setShowSnackbarDelete(false);
        getList();
    }


    const onGetList = (sortObj, paginationObj) => {
        setSort(sortObj)
        setPagination(paginationObj)
    }

    useEffect(() => {
        getList();
    }, [sort, pagination])

    useEffect(() => {
        if (location.state && location.state.open) {
            setShowSnackbar(true);
            setTimeout(() => {
                setShowSnackbar(false);
            }, 6000);
        }
    }, [])

    if (!loaded) return null

    return (
        <Box mt={5} py={2} width={!isDesktop ? '95%' : '80%'} m='auto'>
            <Box width='100%' display='flex' justifyContent='flex-end'>
                <Snackbar
                    show={showSnackbar}
                    boldText={location.state && location.state.name}
                    message={location.state && location.state.message}
                    onClose={() => setShowSnackbar(false)}
                />
                <Snackbar
                    show={showSnackbarDelete}
                    message={'Deleting remote'}
                    undo={undoDelete}
                    onClose={() => setShowSnackbarDelete(false)}
                />

            </Box>
            <Title title={translate(`pos.remoteControl.title`)} />
            <PageListLabel
                label={translate(`pos.remoteControl.title`)}
                buttonHidden={
                    !permissions.functionAction.find(value => value.function === 'TV’s and remote control' && value.isUpdate)
                }
                searchPlaceholder={translate(`pos.remoteControl.search`)}
                btnText={translate(`pos.remoteControl.add`)}
                onChangeText={setSearchText}
                pathname='/Remote/create'
                getList={getList}
                total={totalCount}
            />
            <RemoteTable
                handleDelete={handleDelete}
                buttonHidden={
                    !permissions.functionAction.find(value => value.function === 'TV’s and remote control' && value.isUpdate)
                }
                data={data}
                checked={data.length > 0 && data.filter(item => item.checked)}
                handleCheckMark={handleCheckMark}
                onDelete={() => {
                    setOpenConfirmDialog(true)
                }}
                onClear={onClear}
                total={totalCount}
                getList={onGetList}
            />
            <ConfirmDialog
                open={openConfirmDialog}
                handleClose={() => { setOpenConfirmDialog(false) }}
                handleConfirm={handleDelete}
                ContentText={translate(`pos.remoteControl.confirmDelete`)}
                Tittle={translate(`pos.remoteControl.delete`)} />
        </Box>
    );
}

export default List;